import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

export const MetadataPages = {
  list: 'ListMetadata',
}

const { t } = i18n.global

const title = t('pages.listMetadata')
const path = '/metadatas'

const List: RouteRecordRaw = {
  path: '',
  name: MetadataPages.list,
  component: () => import('@/pages/mainPageWithRoute/metadata/ListMetadataPage.vue'),
  meta: { title, requiresAuth: true },
}

export const Metadatas: RouteRecordRaw = {
  path,
  name: 'Metadatas',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List],
}
